var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9121 2.25057C10.7644 1.44716 9.23678 1.44716 8.08905 2.25057L2.35773 6.26249C1.39222 6.93835 0.855367 8.07383 0.945758 9.24892L1.53327 16.8866C1.64408 18.3271 2.94925 19.3741 4.37946 19.1698L7.02081 18.7924C8.25243 18.6165 9.16726 17.5617 9.16726 16.3175V15.263C9.16726 14.8028 9.54035 14.4297 10.0006 14.4297C10.4608 14.4297 10.8339 14.8028 10.8339 15.263V16.3175C10.8339 17.5617 11.7487 18.6165 12.9804 18.7924L15.6217 19.1698C17.0519 19.3741 18.3571 18.3271 18.4679 16.8866L19.0554 9.24892C19.1458 8.07383 18.609 6.93835 17.6434 6.26249L11.9121 2.25057ZM9.04482 3.61596C9.61868 3.21425 10.3825 3.21425 10.9564 3.61596L16.6877 7.62788C17.1704 7.96581 17.4389 8.53355 17.3937 9.12109L16.8061 16.7588C16.7692 17.239 16.3342 17.5879 15.8574 17.5198L13.2161 17.1425C12.8055 17.0839 12.5006 16.7323 12.5006 16.3175V15.263C12.5006 13.8823 11.3813 12.763 10.0006 12.763C8.61988 12.763 7.50059 13.8823 7.50059 15.263V16.3175C7.50059 16.7323 7.19565 17.0839 6.78511 17.1425L4.14376 17.5198C3.66703 17.5879 3.23197 17.239 3.19503 16.7588L2.60752 9.12109C2.56232 8.53355 2.83075 7.96581 3.3135 7.62788L9.04482 3.61596Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.0176d49d226d95a6831f56d64c726317.svg";
export { ForwardRef as ReactComponent };